import { render, staticRenderFns } from "./FeatureUnavailableModal.vue?vue&type=template&id=a5f2a730&"
import script from "./FeatureUnavailableModal.vue?vue&type=script&lang=js&"
export * from "./FeatureUnavailableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports